<template>
  <div class="container mb-5">
    <HMFileUpload v-model="file"></HMFileUpload>
    <HMUnsplashUpload v-model="file"></HMUnsplashUpload>
    <!-- <HMCanvaUpload v-model="file" class="mt-2"></HMCanvaUpload> -->
    <HMFilePreview v-if="file" :file="file" />
    <input v-model="embedFileUrl" />
    <HMButton @click="embedFile">embedFile</HMButton>
    <div class="row">
      <div class="col">
        <h1>h1 heading</h1>
        <h2>h2 heading</h2>
        <h3>h3 heading</h3>
        <p>paragraph</p>
        <div>
          <small>small</small>
        </div>
        <a href>link</a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="p-0 m-0 bg-light">m0 p0</div>
        <div class="p-1 m-1 bg-light">m1 p1</div>
        <div class="p-2 m-2 bg-light">m2 p2</div>
        <div class="p-3 m-3 bg-light">m3 p3</div>
        <div class="p-4 m-4 bg-light">m4 p4</div>
        <div class="p-5 m-5 bg-light">m5 p5</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter email"
          />
          <small id="emailHelp" class="form-text"
            >We'll never share your email with anyone else.</small
          >
        </div>

        <div class="form-group">
          <label for="validationServer01">First name</label>
          <input
            type="text"
            class="form-control is-valid"
            id="validationServer01"
            placeholder="First name"
            value="Mark"
            required
          />
          <div class="valid-feedback">$t('Looks good!')</div>
        </div>

        <div class="form-group">
          <label for="validationServer04">State</label>
          <input
            type="text"
            class="form-control is-invalid"
            id="validationServer04"
            placeholder="State"
            required
          />
          <div class="invalid-feedback">Please provide a valid state.</div>
        </div>

        <HMTextInput
          rules="required"
          type="text"
          label="HMTextInput"
          v-model="HMTextInput"
        >
          <template slot="prepend"> slot prepend </template>
          <template slot="append"> slot append </template>
        </HMTextInput>

        <HMTextInput
          rules="required"
          type="text"
          label="HMTextInput"
          v-model="HMTextInput"
        ></HMTextInput>

        <div class="mt-5">
          <HMButton class="btn-primary" type="submit"> HMButton </HMButton>
        </div>
        <div class="mt-2">
          <HMButton class="btn-primary" type="submit" disabled>
            HMButton disabled
          </HMButton>
          <HMButton class="btn-primary" type="submit">
            HMButton disabled
          </HMButton>
          <HMButton class="btn-primary" type="submit" :loading="true">
            HMButton loading
          </HMButton>
        </div>

        <div class="mt-5">
          Modal:
          <HMButton class="btn-primary" @click="showModal">
            Show modal
          </HMButton>
        </div>

        <div class="mt-5">
          Tabs:
          <HMSwitchTabs :selected.sync="toggleSwitchSelected">
            <HMSwitchTab name="banana"> Banana </HMSwitchTab>
            <HMSwitchTab name="apple"> Apple </HMSwitchTab>
            <HMSwitchTab name="apple2"> Apple2 </HMSwitchTab>
          </HMSwitchTabs>
        </div>

        <div>
          Translations:
          {{ $t('GENERAL.LOOKS-GOOD') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <HMPaginatedTable
          name="media-test-table"
          api="mediaLibrary/getMedia"
          :fields="this.fields"
        >
          <template slot="edit" slot-scope="{ data }">
            <HMIconButton :icon="['far', 'times']" @click="remove(data)" />
          </template>
        </HMPaginatedTable>
      </div>
    </div>
    <div class="row mt-5">
      <HMCheckBox class="col" v-model="checkBox">Test</HMCheckBox>
      <HMRadio class="col" v-model="radio" group="test" name="test1"
        >Test</HMRadio
      >
      <HMRadio class="col" v-model="radio" group="test" name="test2"
        >Test2</HMRadio
      >
    </div>
    <section class="mb-5">
      <h1>Popovers</h1>
      <span id="popover-test">Hover to test popovers</span>
      <HMPopover target="popover-test">
        <HMPopoverMenuItem>Test1</HMPopoverMenuItem>
        <HMPopoverMenuItem>Test2</HMPopoverMenuItem>
        <HMPopoverMenuItem>Test3</HMPopoverMenuItem>
        <HMPopoverMenuItem>Test4</HMPopoverMenuItem>
      </HMPopover>
    </section>

    Dates:
    <span class="d-block"
      ><b>formatCurrency: </b> {{ $formatCurrency(1000) }}
    </span>
    <span class="d-block"
      ><b>formatNumber: </b> {{ $formatNumber(1000) }}
    </span>
    <span class="d-block"
      ><b>formatDate: </b> {{ $formatDate('2020-09-26T22:00:00Z') }}
    </span>
  </div>
</template>

<script>
import api from '@/core/api/modules/media-libraries';

export default {
  data() {
    return {
      toggleSwitchSelected: 'apple',
      fields: [
        {
          title: 'Title',
          key: 'title',
          cssClass: 'h5',
        },
        {
          title: 'Owner',
          key: 'media.owner.full_name',
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
        },
      ],
      file: null,
      embedFileUrl: null,
      checkBox: false,
      radio: 'test1',
      HMTextInput: '',
    };
  },
  methods: {
    async embedFile() {
      const file = await api.uploadMediaFile({
        embedded_url: this.embedFileUrl,
      });
      this.file = file;
    },
    showModal() {
      this.$modal.show('test-modal');
    },
    hideModal() {
      this.$modal.show('test-modal');
    },
    remove(data) {
      console.log(data);
    },
  },
};
</script>
